import {Text, Modal, ModalOverlay, ModalContent, Center, Flex, Button, useToast} from '@chakra-ui/react';
import {BatteryIcon} from '@eksab/features/store/badges/icons';
import {useRevertPowerConsumptionMutation} from '@eksab/hooks/useRevertPowerConsumptionMutation';
import {useTranslate} from '@eksab/i18n';
import {useInvalidateCompetition} from '../../hooks/useCompetitionQuery';

type RevertBoostModalProps = {
  boostId: number;
  competitionEntryId: number;
  competitionId: number;
  isOpen: boolean;
  onClose: () => void;
};

export const RevertBoostModal = ({
  boostId,
  competitionEntryId,
  competitionId,
  isOpen,
  onClose,
}: RevertBoostModalProps) => {
  const t = useTranslate();

  const toast = useToast();

  const revertPowerConsumptionMutation = useRevertPowerConsumptionMutation();

  const invalidateCompetition = useInvalidateCompetition();

  const onRevertBoost = () => {
    return revertPowerConsumptionMutation.mutate(
      {id: boostId, competition_entry_id: competitionEntryId},
      {
        onSuccess: () => {
          toast({title: t('prize.booster.revert.success'), status: 'success', id: 'boost-reverted-success'});
          invalidateCompetition(competitionId, 'user');
          onClose();
        },

        onError: (e) => {
          toast({
            title: e?.response?.data?.message ?? t('app.errors.try-again'),
            status: 'error',
            id: 'boost-reverted-error',
          });
        },
      },
    );
  };

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w="350px" px="4" pt="8" pb="6" alignItems="center">
        <Center boxSize="14" borderColor="#DAE2DA" borderWidth="1px" rounded="full" mb="3">
          <BatteryIcon />
        </Center>
        <Text color="#ABABAB" fontWeight="500" mb="1">
          {t('prize.booster.revert.boost')}
        </Text>
        <Text fontSize="22px" fontWeight="700" textAlign="center" mb="3.5">
          {t('prize.booster.revert.booster.title')}
        </Text>
        <Flex gap="4">
          <Button
            size="lg"
            bgColor="white"
            textColor="black"
            borderRadius="30px"
            borderColor="black"
            border="1px"
            pos="relative"
            fontWeight="700"
            onClick={onClose}
            _hover={{}}
            _active={{}}
            textTransform="capitalize"
          >
            {t('app.actions.cancel')}
          </Button>
          <Button textTransform="capitalize" onClick={() => onRevertBoost()}>
            {t('prize.booster.revert.boost.cta')}
          </Button>
        </Flex>
      </ModalContent>
    </Modal>
  );
};
